import { Box } from '@air/marketing-primitives';
import Image from 'next/image';

import { HeroData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/globals/Container';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionImage } from '~/old-marketing/components/sections/SectionImage';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { clamp } from '~/utils/clamp';

const TEMPLATE_KEY = 'operators';

export type OperatorsHeroTemplateProps = Pick<HeroData, 'assets' | 'content' | 'id' | 'title'>;

export const OperatorsHeroTemplate = ({ assets, content, id, title }: OperatorsHeroTemplateProps) => {
  const asset = assets?.[0].file;

  return (
    <Section css={{ backgroundColor: '$pigeon025', paddingTop: 226 }} id={id} templateKey={TEMPLATE_KEY}>
      <Container css={{ position: 'relative', maxWidth: 840, textAlign: 'center' }}>
        {title && (
          <SectionTitle css={{ position: 'relative', display: 'inline-block', color: '$jay800' }} size="heading-64">
            <Box css={{ position: 'absolute', width: clamp(49, 99), left: clamp(-51, -102), top: clamp(-18, -36) }}>
              <Image alt="" height={80} src="/marketing/assets/marketing/operators-hero-title-left.svg" width={99} />
            </Box>

            {title}

            <Box css={{ position: 'absolute', width: clamp(40, 80), right: clamp(-30, -60), top: clamp(-16, -32) }}>
              <Image alt="" height={73} src="/marketing/assets/marketing/operators-hero-title-right.svg" width={79} />
            </Box>
          </SectionTitle>
        )}
        {content && <SectionContent content={content} css={{ marginTop: 16, color: '$pigeon700' }} size="ui-20" />}
      </Container>

      {asset && (
        <SectionImage
          css={{ display: 'block', marginX: 'auto', marginTop: 24, marginBottom: -24 }}
          height={asset.details.image.height}
          src={asset.url}
          width={asset.details.image.width}
        />
      )}
    </Section>
  );
};

OperatorsHeroTemplate.templateKey = TEMPLATE_KEY;
